
export * from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$time-picker.js';

import __default__ from '../../../frontend-taglib-clay/__liferay__/exports/@clayui$time-picker.js';
export default __default__;
